import { Component } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import { User } from '../../models/user';
import { Dnd5eSheet } from '../../models/dnd5e-sheet';
import { Permission } from '../../models/permission';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent {
  dnd5e_sheets: Observable<Dnd5eSheet[]>;
  permissions: Observable<Permission[]>;
  private usersCollection: AngularFirestoreCollection<User>;
  private dnd5eSheetsCollection: AngularFirestoreCollection<Dnd5eSheet>;

  constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth) {
    // Grab current uid from afAuth, move this to a Module eventually
    afAuth.authState.subscribe(u => {
      this.fetchDnd5eSheets(u.uid);
    });
  }

  // List all dnd5e-sheets where owner_id == current_uid
  fetchDnd5eSheets(uid) {
    this.dnd5eSheetsCollection = this.afs.collection<Dnd5eSheet>('dnd5e-sheets', ref => ref.where('owner_id', '==', uid));
    this.dnd5e_sheets = this.dnd5eSheetsCollection.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Dnd5eSheet;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });

    this.permissions = this.afs.collection('permissions', ref => ref.where('uid', '==', uid)).snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Permission;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });

  }

  // updateUser(key: string, user: User) {
  //   this.usersCollection.doc(key).update(user)
  // }

  // addUser(user: User) {
  //   this.usersCollection.add(user);
  // }

  // We probably don't need this anymore
  // this.usersCollection = afs.collection<User>('users');
  // this.users = this.usersCollection.snapshotChanges().map(actions => {
  //   return actions.map(a => {
  //     const data = a.payload.doc.data() as User;
  //     const id = a.payload.doc.id;
  //     return { id, ...data };
  //   });
  // });
}



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/game/dashboard/dashboard.component.ts